<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>虚拟订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
<!--      <el-form-item label="商品名称">-->
<!--        <el-input size="small" clearable v-model="formInline.productName" placeholder="请输入商品名称"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="物流单号">-->
<!--        <el-input size="small" clearable v-model="formInline.logisticsNo" placeholder="请输入物流单号"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="虚拟订单文本">
        <el-input size="small" clearable v-model="formInline.fakeMsg" placeholder="请输入虚拟订单文本"></el-input>
      </el-form-item>

      <el-form-item label="订单创建时间">
          <el-date-picker
          size="small"
          v-model="dateRange"
          type="daterange"
          @change="dateChange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="flex align timer-area">
      <div class="timer-lable">
        播放频率(毫秒)
      </div>
      <div class="timer-content flex align justify">
        <div class="timer-content-num" v-show="!isTimeEdit">
          {{timerData}}
        </div>
        <div v-show="isTimeEdit">
          <el-input-number
            size="small"
            clearable
            v-model="editTime"
            placeholder="请输入播放频率"
          ></el-input-number>
        </div>
      </div>
      <div>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-edit"
          @click="isTimeEdit= true"
          v-show="!isTimeEdit"
        >编辑
        </el-button>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-edit"
          @click="saveTimer()"
          v-show="isTimeEdit"
        >保存
        </el-button>
      </div>
    </div>
    <el-row  :gutter="10">

    </el-row>
    <el-row style="margin-bottom: 10px">
      <el-button
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="handleAdd()"
      >新增
      </el-button
      >
      <el-button
        size="small"
        type="warning"
        plain
        :disabled="isGroundingBtn"
        icon="el-icon-delete"
        @click="handleDel()"
      >批量删除
      </el-button
      >
    </el-row>
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" @selection-change="selectChange" border element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column align="center" type="selection" width="50">
      </el-table-column>
      <el-table-column sortable prop="fakeMsg" label="虚拟订单文本"  show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="fakeMsg" label="头像" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="imgarea">
            <el-image
              class="table-img"
              style="width: 36px; height: 24px"
              :src="scope.row.avatarUrl"
            >
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="createDate" label="创建时间" width="160" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.createDate|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="150" fixed="right">
        <template slot-scope="scope">

          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row, '')"
          >编辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDel(scope.row)"
          >删除
          </el-button>
<!--          <el-button size="mini" :disabled="scope.row.tradeState!='SHIPPED' || scope.row.thirdFlag!='2'" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
<!--          <el-button size="mini" :disabled="scope.row.tradeState!='SHIPPED' || scope.row.thirdFlag=='2'" type="warning" plain @click="deleteUser(scope.row)">订单重推</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @close="closeDialog('exportForm')">
      <el-form label-width="120px" :model="exportForm" ref="exportForm" :rules="rules">

            <el-form-item label="虚拟订单文本" prop="fakeMsg">
              <el-input size="small" clearable v-model="exportForm.fakeMsg" placeholder="请输入虚拟订单文本"></el-input>
            </el-form-item>
            <el-form-item label="头像" prop="avatar">

              <el-upload
                :class="{ uoloadSty: showBtnDealImg, disUoloadSty: noneBtnImg }"
                ref="detailImageUpload"
                action="#"
                list-type="picture-card"
                :file-list="fileList"
                :limit="1"
                :multiple="false"
                :before-upload="beforeAvatarUpload"
                :on-change="swiperImgChange"
                :http-request="uploadArrBinary"
              >
                <i slot="default" class="el-icon-plus" ></i>
                <div slot="file" slot-scope="{ file }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt=""
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
                <div slot="tip" class="img_size_tip">
                  避免影响小程序内显示效果，请上传：1/1比例图片
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible" append-to-body>
                <img width="100%" :src="dialogImageUrl" alt=""/>
              </el-dialog>
            </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('exportForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('exportForm')">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  fakeOrderList,
  addFakeOrder,
  getFakeOrder,
  editFakeOrder,
  delFakeOrder,
  getTimer,
  editTimer
} from "@/api/payMg.js"
import {upimg} from "@/api/userMG";
import {timestampToTime} from '../../utils/util'
import Pagination from '../../components/Pagination'
import {Loading} from "element-ui";
import {exportOrder} from "@/api/system";
import exportFile from '@/utils/exportFile'
import {GoodsEdit, GoodsSave} from "../../api/basisMG";
export default {
  data() {
    return {
      disabled: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      fileList:[],
      dialogImageUrl:null,
      dialogVisible:!1,
      noneBtnImg: false, //图片按钮显示隐藏
      showBtnDealImg: true,
      detailImageArr:[],
      dateRange:null,
      formInline: {
        page: 1,
        limit: 10,
        startTime: null,
        endTime: null,
        fakeMsg:null
      },
      exportForm:{
        fakeMsg:null,
        avatar:null
      },
      rules:{
        fakeMsg: [
          {required: true, message: "请输入虚拟订单文本", trigger: ["change","blur"]}
        ],
        avatar:[{required: true, message: "请上传头像", trigger: ["change","blur"]}]
      },

      listData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      ids: '',
      isGroundingBtn:!0,
      timerData:null,
      editTime:'',
      isTimeEdit:!1
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    this.getdata(this.formInline);
    this.getTimerData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    dateChange(v){
      console.log(v);
      this.formInline.startTime	= v[0]
      this.formInline.endTime	= v[1]
    },
    // 获取表格数据
    getdata(parameter) {
      this.loading = true
      fakeOrderList(parameter)
        .then(res => {
          this.loading = false
          if (res.rsp_code !== 200) {
            this.$message({
              type: 'info',
              message: res.rsp_msg
            })
          } else {
            this.listData = res.body.records
            console.log(this.listData);
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.body.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    //获取播放频率数据
    getTimerData() {
      getTimer().then(res => {
        if (res.rsp_code !== 200) {
          this.$message({
            type: 'info',
            message: res.rsp_msg
          })
        } else {
          this.timerData = res.body.time
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page=1
      this.getdata(this.formInline)
    },
    // selection选择
    selectChange(selection) {
      console.log('selection',selection);
      if (selection.length > 0) {
        this.isGroundingBtn = false
      } else {
        this.isGroundingBtn = true
      }
      let ids;
      ids = selection.map(item => item.id)
      this.ids = ids.join()
    },
    //新增操作
    handleAdd() {
      this.title = "新增"
      this.editFormVisible = true
    },
    //显示编辑导出界面
    async handleEdit(index, row) {
      let that = this;
      this.title = "编辑"
      that.loading = true;
      getFakeOrder(row.id).then((res) => {
        that.loading = false;
        if (res.rsp_code == 200) {
            this.exportForm = res.body
          let imgArr = res.body.avatar.split(";");

            this.fileList.push({url: res.body.avatarUrl});
            this.detailImageArr.push(imgArr[0]);

          this.noneBtnImg = this.fileList.length >= 1;
        } else {
          this.$message({
            type: "info",
            message: res.rsp_msg,
          });
        }
      })
        .catch((err) => {
          this.loading = false;
          this.$message.error("保存失败，请稍后再试！");
        });
      this.editFormVisible = true
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      let that = this;
      this.$refs[editData].validate((valid) => {
        if (valid) {

          let subType = that.title == "新增" ? addFakeOrder : editFakeOrder;
          // if (this.editForm.flagList && this.editForm.flagList.length > 0) {
          //   this.editForm.flag = this.editForm.flagList.join(";");
          // }
          that.loading = true;
          console.log(that.exportForm)
          subType(that.exportForm)
            .then((res) => {
              that.loading = false;
              that.editFormVisible = false
              if (res.rsp_code == 200) {
                this.getdata(this.formInline);
                this.editFormVisible = false;
                this.fileList = [];
                this.detailImageArr = [];
                this.$message({
                  type: "success",
                  message: "保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.rsp_msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("保存失败，请稍后再试！");
            });
        } else {
          return false
        }
      })
    },
    // 删除
    handleDel(row) {
      this.$confirm('确定要删除该数据吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids;
          if(row) {
            ids = row.id
          }
          else {
            ids = this.ids
          }

          delFakeOrder(ids)
            .then(res => {
              if (res.rsp_code==200) {
                this.$message({
                  type: 'success',
                  message: res.rsp_msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.rsp_msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('操作失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      console.log(1111)
      this.editFormVisible = false
      this.$refs[formName].resetFields()
      this.exportForm= {
        fakeMsg:null,
        avatar:null
      }
      this.fileList = [];
      this.detailImageArr = [];
      this.noneBtnImg =false
    },


    // 轮播图自定义上传
    uploadArrBinary(filePath) {
      let formData = new FormData();
      formData.append("file", filePath.file);
      upimg(formData).then((res) => {
        this.detailImageArr.push(res.body.imageNo);
        this.exportForm.avatar = this.detailImageArr.join(";");
      });
    },

    handleRemove(file) {
      const index = this.fileList.findIndex((e) => e.uid === file.uid);
      this.fileList.splice(index, 1);
      this.noneBtnImg = this.fileList.length >= 1; //添加按钮显隐
      // 删除的时候把this.editForm.detailImage 对应的imgNo删掉
      this.detailImageArr.splice(index, 1);
      this.exportForm.avatar = this.detailImageArr.join(";");
    },
    // 多图预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    swiperImgChange(file, fileList) {
      this.fileList = fileList;
      this.noneBtnImg = fileList.length >= 1;
    },
    beforeAvatarUpload(file) {
      // console.log(file,'图片文件before');
      const isJPG =
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("只能上传jpg或png格式!");
      }
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
      // return isLt2M;
    },
    saveTimer() {
      let data = {
        /** 频率名称 */
        "timerName": "虚假订单频率",
        /** 频率 */
        "time": this.editTime
      }
      editTimer(data).then(res => {
        if (res.rsp_code==200) {
          this.$message({
            type: 'success',
            message: res.rsp_msg
          })
          this.getTimerData()
          this.isTimeEdit = false
        } else {
          this.$message({
            type: 'info',
            message: res.rsp_msg
          })
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error('操作失败，请稍后再试！')
        })
    }
  }
}
</script>

<style scoped>
.el-select{
  width: 100%;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
/* 上传按钮显示隐藏 */
.uoloadSty .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

.disUoloadSty .el-upload--picture-card {
  display: none; /* 上传按钮隐藏 */
}
.flex{
  display: flex;
}
.fl-1{
  flex: 1;

}
.flex-col{
  flex-direction:column;
}
.justify{
  justify-content: center;
}
.align{
  align-items: center;
}
.timer-area{
  margin-bottom: 10px;
}
.timer-lable{
  padding: 0 5px;
}
.timer-content{
  height: 100%;
  padding: 0 10px;
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}
.timer-content-num{
  line-height: 1;
  font-size: 20px;
}
</style>







// WEBPACK FOOTER //
// src/views/pay/fakeOrder.vue